export default function EmptyState({ icon: Icon, title, subtitle, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center px-6 py-16 text-center ${className}`}>
      {Icon && (
        <div className="mb-4 text-primary opacity-80">
          <Icon className="h-16 w-16" strokeWidth={1.5} />
        </div>
      )}
      <p className="text-base font-semibold text-gray-700">{title}</p>
      {subtitle && <p className="mt-2 text-sm text-gray-500">{subtitle}</p>}
    </div>
  );
}
